export default {
  'order-status-arrival': {
    name: 'Order ETA Notification',
    icon: 'shipping-timed',
    threshold: { prefix: 'Within', suffix: 'Minutes Away' },
    condition: { prefix: 'For', suffix: 'Orders' }
  },
  'order-status-complete': {
    name: 'Order Complete Notification',
    icon: 'clipboard-check',
    threshold: { prefix: '', suffix: '' },
    condition: { prefix: 'For', suffix: 'Orders' }
  },
  'order-status-dispatched': {
    name: 'Order Dispatched Notification',
    icon: 'dolly',
    threshold: { prefix: '', suffix: '' },
    condition: { prefix: 'For', suffix: 'Orders' }
  },
  'order-status-feedback': {
    name: 'Order Feedback Notification',
    icon: 'star-half-alt',
    threshold: { prefix: '', suffix: '' },
    condition: { prefix: 'For', suffix: 'Orders' }
  }
}